import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1280 },
    items: 4,
  },
  desktop: {
    breakpoint: { max: 1280, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 720 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 720, min: 0 },
    items: 1,
  },
};

function ButtonGroup({ textColor, next, previous }) {
  return (
    <div className="carousel-button-group">
      <button
        className="absolute top-1/2 -translate-y-1/2 left-[-1.5rem]"
        type="button"
        onClick={() => previous()}
      >
        <FiChevronLeft size={24} color={textColor} />
      </button>
      <button
        className="absolute top-1/2 -translate-y-1/2 right-[-1.5rem]"
        type="button"
        onClick={() => next()}
      >
        <FiChevronRight size={24} color={textColor} />
      </button>
    </div>
  );
}

function CustomDot({ onClick, active }) {
  return (
    <button
      type="button"
      onClick={(e) => {
        onClick();
        e.preventDefault();
      }}
      className="w-[12px] h-[12px] mx-[8px] bg-white rounded-full opacity-50 hover:opacity-100 focus:opacity-100 focus:outline-none"
      style={{ opacity: active ? '100%' : '50%' }}
    />
  );
}

export default function MultiSlider({
  children,
  textColor = 'var(--text-dark)',
  hasButton = false,
  ...options
}) {
  if (!children?.length > 0) return null;

  const sliderOptions = {
    responsive,
    arrows: false,
    showDots: true,
    customDot: <CustomDot />,
    ssr: true,
    infinite: true,
    autoPlay: true,
    autoPlaySpeed: 2500,
    transitionDuration: 0,
    customButtonGroup: <ButtonGroup textColor={textColor} />,
    renderButtonGroupOutside: true,
    renderDotsOutside: true,
    containerClass: 'relative',
    dotListClass: '!-bottom-10',
    ...options,
  };

  return (
    <div className={`relative ${hasButton ? 'mb-20' : 'mb-12'}`}>
      <Carousel responsive={responsive} {...sliderOptions}>
        {children}
      </Carousel>
    </div>
  );
}
